import React, { useState } from 'react';
import { Container, Card, Nav } from 'react-bootstrap';
import './JobVacancies.css'; 
import { Link, useNavigate } from 'react-router-dom';

const JobVacancies = () => {
  const [activeTab, setActiveTab] = useState('skills');
  const navigate = useNavigate();

  // Updated dataset: Reconfigured arrays of objects with 'item' and 'name' properties
  const tabContentData = {
    skills: [
      { item: 'Python', name: 'python' },
      { item: 'SQL', name: 'sql' },
      { item: 'Excel', name: 'excel' },
      { item: 'Java', name: 'java' },
      { item: 'AWS', name: 'aws' },
      { item: 'Sales', name: 'sales' },
      { item: 'Ms Office', name: 'ms-office' },
      { item: 'Javascript', name: 'javascript' },
      { item: 'Git', name: 'git' },
      { item: 'Docker', name: 'docker' },
      { item: 'Azure', name: 'azure' },
      { item: 'Kubernetes', name: 'kubernetes' },
      { item: 'Lead Generation', name: 'lead-generation' },
      { item: 'GCP', name: 'gcp' },
      { item: 'Team Management', name: 'team-management' },
      { item: 'Power BI', name: 'power-bi' },
      { item: 'Data Analysis', name: 'data-analysis' },
      { item: 'Time Management', name: 'time-management' },
      { item: 'Communication', name: 'communication' },
      { item: 'Jenkins', name: 'jenkins' }
    ],
    location: [
      { item: 'Bangalore', name: 'bangalore' },
      { item: 'Mumbai', name: 'mumbai' },
      { item: 'Delhi NCR', name: 'delhi-ncr' },
      { item: 'Hyderabad', name: 'hyderabad' },
      { item: 'Pune', name: 'pune' },
      { item: 'Chennai', name: 'chennai' },
      { item: 'Kolkata', name: 'kolkata' },
      { item: 'Ahmedabad', name: 'ahmedabad' },
      { item: 'Remote', name: 'remote' },
      { item: 'Work From Home', name: 'work-from-home' },
      { item: 'Noida', name: 'noida' },
      { item: 'Gurgaon', name: 'gurgaon' },
      { item: 'International Jobs', name: 'international-jobs' },
      { item: 'Dubai', name: 'dubai' },
      { item: 'Singapore', name: 'singapore' },
      { item: 'USA', name: 'usa' }
    ],
    industry: [
      { item: 'IT Services', name: 'it-services' },
      { item: 'Software Product', name: 'software-product' },
      { item: 'Banking & Finance', name: 'banking-finance' },
      { item: 'E-Commerce', name: 'e-commerce' },
      { item: 'Healthcare', name: 'healthcare' },
      { item: 'EdTech', name: 'edtech' },
      { item: 'Manufacturing', name: 'manufacturing' },
      { item: 'Automotive', name: 'automotive' },
      { item: 'Telecom', name: 'telecom' },
      { item: 'Real Estate', name: 'real-estate' },
      { item: 'Logistics', name: 'logistics' },
      { item: 'Retail', name: 'retail' },
      { item: 'Consulting', name: 'consulting' }
    ],
    functions: [
      { item: 'Software Engineering', name: 'software-engineering' },
      { item: 'Data & Analytics', name: 'data-analytics' },
      { item: 'Sales & Marketing', name: 'sales-marketing' },
      { item: 'Human Resources', name: 'human-resources' },
      { item: 'Finance & Accounting', name: 'finance-accounting' },
      { item: 'Customer Support', name: 'customer-support' },
      { item: 'Operations', name: 'operations' },
      { item: 'Product Management', name: 'product-management' },
      { item: 'Design & Creative', name: 'design-creative' },
      { item: 'Quality Assurance', name: 'quality-assurance' }
    ],
    roles: [
      { item: 'Full Stack Developer', name: 'full-stack-developer' },
      { item: 'Data Scientist', name: 'data-scientist' },
      { item: 'Business Analyst', name: 'business-analyst' },
      { item: 'HR Manager', name: 'hr-manager' },
      { item: 'Sales Executive', name: 'sales-executive' },
      { item: 'DevOps Engineer', name: 'devops-engineer' },
      { item: 'UI/UX Designer', name: 'ui-ux-designer' },
      { item: 'Project Manager', name: 'project-manager' },
      { item: 'Accountant', name: 'accountant' },
      { item: 'Content Writer', name: 'content-writer' },
      { item: 'Product Owner', name: 'product-owner' }
    ],
    company: [
      { item: 'Google', name: 'google' },
      { item: 'Microsoft', name: 'microsoft' },
      { item: 'Amazon', name: 'amazon' },
      { item: 'TCS', name: 'tcs' },
      { item: 'Infosys', name: 'infosys' },
      { item: 'Wipro', name: 'wipro' },
      { item: 'Accenture', name: 'accenture' },
      { item: 'Cognizant', name: 'cognizant' },
      { item: 'Capgemini', name: 'capgemini' },
      { item: 'Deloitte', name: 'deloitte' },
      { item: 'Meta', name: 'meta' },
      { item: 'Netflix', name: 'netflix' }
    ]
  };

  return (
    <Container className="my-4">
      {/* Scoped parent container class wrapper */}
      <Card className="placement-vacancies-card shadow-sm border-1">
        <Card.Body className="p-4">
          
          {/* Main Title Head */}
          <h4 className="section-title mb-3">Find job vacancies by</h4>

          {/* Navigation Category Tabs */}
          <Nav 
            variant="tabs" 
            activeKey={activeTab} 
            onSelect={(k) => setActiveTab(k)}
            className="category-tabs mb-4"
          >
            <Nav.Item>
              <Nav.Link eventKey="skills">Skills</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="location">Location</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="industry">Industry</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="functions">Functions</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="roles">Roles</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="company">Company</Nav.Link>
            </Nav.Item>
          </Nav>

          {/* Grid Layout of Capsule Badges */}
          <div className="pills-container mb-4">
            <div className="pills-flex-wrap">
              {tabContentData[activeTab].map((items, index) => (
                <div
                  key={index} 
                  onClick={() => navigate(`/jobexp?id=${items?.name}`)}
                  className="vacancy-pill-btn"
                >
                  {items.item}
                </div>
              ))}
            </div>
          </div>

          {/* Foot Action Button Redirection */}
          <div className="view-all-wrapper">
            {/* Fixed the out-of-scope variable reference here by passing the active category name instead */}
            <div 
              onClick={() => navigate(`/jobexp?category=${activeTab}`)}
              className="view-all-link"
            >
              View all jobs by {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}{' '}
              <span className="arrow-icon">➔</span>
            </div>
          </div>

        </Card.Body>
      </Card>
    </Container>
  );
};

export default JobVacancies;